exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  padding: 2rem; }\n  :host #header {\n    margin: 2rem; }\n  :host textarea {\n    overflow: hidden;\n    resize: none; }\n  #map {\n  height: 200px; }\n  #map img {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -100%);\n            transform: translate(-50%, -100%);\n    z-index: 10000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/notifications/notification-edit/notification-edit.component.scss
// module id = ../../../../../src/app/notifications/notification-edit/notification-edit.component.scss
// module chunks = main